import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { translate } from "react-i18next";
import mapObjIndexed from "ramda/src/mapObjIndexed";
import values from "ramda/src/values";
import compose from "ramda/src/compose";
import { func } from "prop-types";

import {
  RadioButton,
  Button,
  FloatLabelInput,
  FloatLabelTextArea,
  FloatLabelSelect,
} from "shared/components";
import Loader from "../../../../components/Loading";
import styles from "../../styles.css";
import { asyncValidate, shouldAsyncValidate } from "redux-form-yup";
import * as Yup from "yup";
import * as Mask from "../../../../services/utils/mask";
import { createCommonIncident } from "../../../../services/state/actions";

let linkTypes = [
  {
    label: "Algar LP",
    value: "Algar LP",
    checked: true,
  },
  {
    label: "Terceiro",
    value: "Terceiro",
    checked: true,
  },
];

class VideoConferenceForm extends Component {
  state = {
    isOpenProducts: this.props.isOpen,
    products: null,
    circuit: null,
  };

  onSubmit = (form) => {
    const {
      t,
      createCommonIncident,
      onNextStep,
      onReset,
      linkType,
    } = this.props;

    const checklist = {
      data: { ...form, linkType },
      labels: {
        videoConferenceIp: t("MSG_0219"),
        type: t("MSG_0220"),
        linkType: t("MSG_0223"),
        reason: t("MSG_0202"),
        testingScheduler: t("MSG_0205"),
        contactPhone: t("MSG_0206"),
      },
    };

    return createCommonIncident(checklist, onNextStep, onReset);
  };

  changeRadio = (e) => {
    linkTypes.map((item) => {
      if (item.value === e.target.value) {
        item.checked = true;
        return this.setState({
          userNotificationMethod: e.target.value,
        });
      }
      return (item.checked = true);
    });
  };

  renderRadioField(field) {
    const { id, name, text } = field;

    return (
      <div className={styles.radioRoot}>
        <span className={styles.titleRadio}>{text}</span>
        <RadioButton
          {...field.input}
          name={name}
          id={id}
          options={field.options}
          onChange={field.onchange}
        />
      </div>
    );
  }

  renderInputField(field) {
    const {
      meta: { touched, error, invalid },
    } = field;
    return (
      <FloatLabelInput
        {...field.input}
        id={field.id}
        type={field.type ? field.type : "text"}
        label={field.label}
        maxLength={field.maxLength}
        invalid={touched && invalid}
        error={error}
        value={field.input.value ? field.input.value : ""}
      />
    );
  }

  renderSelectField(field) {
    const {
      meta: { touched, error, invalid },
    } = field;

    const options = values(
      mapObjIndexed((label, value) => ({ label, value }), field.options)
    );

    return (
      <FloatLabelSelect
        id={field.id}
        options={options}
        label={field.label}
        invalid={touched && invalid}
        error={error}
        defaultOption
        {...field.input}
      />
    );
  }

  renderTextAreaField(field) {
    const {
      meta: { touched, error, invalid },
    } = field;
    return (
      <FloatLabelTextArea
        id={field.id}
        name={field.name}
        label={field.label}
        preset="modalTextArea"
        onChange={field.input.onChange}
        invalid={touched && invalid}
        error={error}
        value={field.input.value ? field.input.value : ""}
        noResize
      />
    );
  }

  render() {
    const { t, handleSubmit, submitting, onCancel } = this.props;

    return (
      <Fragment>
        <span>{t("MSG_0211")}</span>
        <form onSubmit={handleSubmit(this.onSubmit)}>
          <Field
            id="videoConferenceIp"
            label={t("MSG_0219")}
            name="videoConferenceIp"
            component={this.renderInputField}
          />

          <Field
            id="type"
            label={t("MSG_0220")}
            name="type"
            component={this.renderInputField}
          />

          <Field
            id="linkType"
            name="linkType"
            component={this.renderRadioField}
            onchange={this.changeRadio}
            options={linkTypes}
            text={t("MSG_0223")}
          />

          <Field
            id="reason"
            label={t("MSG_0202")}
            maxLength={500}
            name="reason"
            component={this.renderTextAreaField}
          />

          <Field
            id="testingScheduler"
            type="text"
            label={t("MSG_0205")}
            name="testingScheduler"
            component={this.renderInputField}
          />

          <Field
            id="contactPhone"
            name="contactPhone"
            component={this.renderInputField}
            label={t("MSG_0206")}
            format={Mask.phone}
            maxLength="15"
            normalize={Mask.algarPhone}
          />

          <div className={styles.actions}>
            <Button onClick={onCancel} relevance="low" toLinkBtn>
              {t("MSG_0292")}
            </Button>

            <Button type="submit" relevance="normal" callToAction>
              {t("MSG_0007")}
            </Button>
          </div>
        </form>

        <Loader isOpen={submitting} />
      </Fragment>
    );
  }
}

function createValidationSchema() {
  return Yup.object().shape({
    videoConferenceIp: Yup.string().required("Campo obrigatório"),

    type: Yup.string().required("Campo obrigatório"),

    reason: Yup.string().required("Campo obrigatório"),

    testingScheduler: Yup.string().required("Campo obrigatório"),

    contactPhone: Yup.string()
      .required("Campo obrigatório")
      .matches(/^0\d{1,11}$/, {
        message: "Número de telefone inválido",
        excludeEmptyString: true,
      }),
  });
}

VideoConferenceForm.propTypes = {
  onCancel: func.isRequired,
  onSubmit: func.isRequired,
};

const reduxFormConfig = {
  form: "VideoConferenceForm",
  asyncValidate: asyncValidate(createValidationSchema()),
  shouldAsyncValidate,
};

const enhance = compose(
  translate(),
  connect(null, { createCommonIncident }),
  reduxForm(reduxFormConfig)
);

export default enhance(VideoConferenceForm);



// WEBPACK FOOTER //
// ./src/components/RepairWizard/components/ModalVideoConference/VideoConferenceForm.js